import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useUserStore } from '@/stores/user'

export function requireAuth(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const userStore = useUserStore()
  
  // Initialize auth state from localStorage
  userStore.initializeAuth()
  
  if (!userStore.isAuthenticated) {
    // Redirect to login
    next('/login')
    return
  }
  
  next()
}

export function requireAdmin(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const userStore = useUserStore()
  
  // Initialize auth state from localStorage
  userStore.initializeAuth()
  
  if (!userStore.isAuthenticated) {
    // Redirect to login
    next('/login')
    return
  }
  
  if (!userStore.isAdmin) {
    // User is authenticated but not admin
    next('/login') // Redirect to regular login or forbidden page
    return
  }
  
  next()
}

export function redirectIfAuthenticated(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const userStore = useUserStore()
  
  // Initialize auth state from localStorage
  userStore.initializeAuth()
  
  if (userStore.isAuthenticated && userStore.isAdmin) {
    // Already logged in as admin, redirect to admin dashboard
    next('/admin')
    return
  }
  
  next()
}
